import {
  Desciption,
  EditFieldsList,
  EntityTable,
  FilterFields,
  Panel,
} from 'components/UIComponents/EntityTable';
import { AwarePanel } from 'components/UIComponents/EntityTable/EntityTable.components';
import { SectionType } from 'pages/ClaimsContractsToolPage/types';
import { SettingsContentPanel } from 'pages/SettingsPage/components/SettingsContentPanel';
import { DynamicFieldFilter } from './DynamicFieldFilter';
import { DynamicFieldInput } from './DynamicFieldInput';
import './DynamicFields.css';
import { useEditAndFilterDynamicFields } from './useDynamicFields';
import { dynamicFieldsActions } from '../../../../reducer/dynamicFields';
import { useEffect } from 'react';
import { useAppDispatch } from '../../../../hooks/reducerHooks';
import { ApLoaderDefault } from '@alixpartners/ui-components';

export function DynamicFields() {
  const dispatch = useAppDispatch();
  const { status, claimsData, onFilter, onEditSave, fetching } =
    useEditAndFilterDynamicFields(SectionType.Claims);

  useEffect(() => {
    dispatch(dynamicFieldsActions.idle());
  }, [dispatch]);

  return (
    <SettingsContentPanel>
      <section className="dynamicfields">
        <EntityTable
          items={claimsData ?? []}
          status={status}
          editColumnKeys={['name', 'type', 'displayIn', 'enabled']}
          filterColumnKeys={['type']}
          inputComponent={DynamicFieldInput}
          filterComponent={DynamicFieldFilter}
          onFilter={onFilter}
          onEditSave={onEditSave}
          section={SectionType.Claims}
        >
          <Panel title="Dynamic fields">
            <Desciption>
              Dynamic fields can be added to capture additonal data for all claims.
              These fields will appear on every claim and will also be available as a
              column within the claims tables that can be searched and filtered.
            </Desciption>
            <FilterFields headers={['Filter fields']} />
          </Panel>

          <AwarePanel title="Manage dynamic fields" className="edit-fields">
            {fetching ? (
              <ApLoaderDefault loaderSize="lg" />
            ) : (
              <EditFieldsList
                headers={[
                  'Field name',
                  'Field type',
                  'Display in',
                  'Enabled/Disabled',
                ]}
              />
            )}
          </AwarePanel>
        </EntityTable>
      </section>
    </SettingsContentPanel>
  );
}
